<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSearch" :autoFormCreate="(form) => { this.searchForm = form }">
        <a-row :gutter="48">
          <a-col :span="6">
            <a-form-item label="搜索商品" fieldDecoratorId="name">
              <a-input placeholder="商品名称" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="兑换门店" fieldDecoratorId="branch_id">
              <a-select placeholder="请选择" show-search option-filter-prop="children">
                <a-select-option v-for="item in branches" :key="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="库存为0" fieldDecoratorId="is_zero">
              <a-select placeholder="请选择" allowClear>
                <a-select-option :key="0">全部</a-select-option>
                <a-select-option :key="1">是</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="搜索SKU" fieldDecoratorId="sku">
              <a-input placeholder="sku" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="是否上架" fieldDecoratorId="is_listing">
              <a-select placeholder="请选择" allowClear>
                <a-select-option :key="0">全部</a-select-option>
                <a-select-option :key="2">上架</a-select-option>
                <a-select-option :key="1">下架</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType='submit'>查询</a-button>
              <a-divider type="vertical" />
              <a-button style="margin-left: 8px" @click="handleChange">调拨</a-button>
              <a-divider type="vertical" />
              <a-button style="margin-left: 8px" @click="handleExport">导出</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table ref="table" size="default" :columns="columns" :data="loadData">
      <template slot="pic_url" slot-scope="text">
        <img :src="text" class="pic">
      </template>
      <template slot="barcode_url" slot-scope="text,record">
        <a class="barcode" :href="text" rel="external nofollow"
          :download="'sku'.concat(record.goods_name).concat('.png')"><img :src="text"></a>
      </template>
      <template slot="barcode69" slot-scope="text">
        <span>{{ text || "-" }}</span>
      </template>
      <template slot="is_listing" slot-scope="text">
        {{ text ? '上架' : '未上架' }}
      </template>
      <template slot="action" slot-scope="text, record">
        <div class='editable-row-operations'>
          <a @click="handleView(record)">查看</a>
          <a-divider type="vertical" />
          <a-popconfirm placement="bottom" ok-text="打印" cancel-text="取消" @confirm="handlePrint(record)"
            @visibleChange="(value) => { if (value) printNum = 1 }">
            <template slot="title">
              请输入打印数量<br />
              <a-input-number v-model="printNum" style="width:54px" :min="1" :max="99" :step="1" />
            </template>
            <a>打印条码</a>
          </a-popconfirm>
        </div>
      </template>
    </s-table>
  </a-card>
</template>
<script>
import STable from '@/components/table/'
import AInput from 'ant-design-vue/es/input/Input'
import { getStockList } from '@/api/stock'
import { getBranchList } from '@/api/branch'
import { encodeJsonToQuery } from '@/utils/util'
import { ACCESS_TOKEN } from "@/store/mutation-types"

export default {
  name: "StockList",
  components: {
    AInput,
    STable
  },
  data() {
    return {
      printNum: 1,
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      mdl: {},
      // 查询参数
      searchForm: null,
      queryParam: {},
      // 表头
      branches: [],
      columns: [
        {
          title: '图片',
          dataIndex: 'pic_url',
          scopedSlots: { customRender: 'pic_url' },
        },
        {
          title: '名字',
          dataIndex: 'goods_name'
        },
        {
          title: '条形码',
          dataIndex: 'barcode_url',
          scopedSlots: { customRender: 'barcode_url' },
        },
        {
          title: '69码',
          dataIndex: 'barcode69',
          scopedSlots: { customRender: 'barcode69' },
        },
        {
          title: 'sku',
          dataIndex: 'sku'
        },
        {
          title: '是否上架',
          dataIndex: 'is_listing',
          scopedSlots: { customRender: 'is_listing' },
        },
        {
          title: '库存数量',
          dataIndex: 'unit_stock',
        },
        {
          title: '兑换规则',
          dataIndex: 'exchange_price'
        },
        {
          title: '奥莱币价格',
          dataIndex: 'outlets_price'
        },
        {
          title: '所属门店',
          dataIndex: 'branch_name'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }
      ],
      stocks: [],
      innerColumns: [
        {
          title: '图片',
          dataIndex: 'sku.cover',
          scopedSlots: { customRender: 'cover' },
        },
        {
          title: 'SKU',
          dataIndex: 'sku.attribute'
        },
        {
          title: '在途库存',
          dataIndex: 'transit_stock',
        },
        {
          title: '当前库存',
          dataIndex: 'unit_stock',
        },

      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: params => {
        return getStockList(Object.assign(params, this.queryParam)).then(res => res)
      },
    }
  },
  created() {
    this.getBranchList()
  },
  methods: {
    getBranchList: function () {
      getBranchList().then(res => {
        this.branches = res.list
      })
    },
    handlePrint(record) {
      let duihuan = record.is_outlets ? `奥莱币:${record.outlets_price}` : `兑换数:${record.exchange_price}`
      let str = `${record.id.toString().padStart(12, "0")},,${record.goods_name},,${duihuan}`
      if (record.retail_price) {
        str += ` 售价:${record.retail_price.toFixed(2)}元`
      }
      str += `,,${this.printNum}`
      let a = document.createElement("a")
      a.href = `wawaprinter://${str}`
      a.click()
    },
    handleSearch(e) {
      e.preventDefault()
      this.queryParam = {
        name: this.searchForm.getFieldValue('name'),
        branch_id: this.searchForm.getFieldValue('branch_id'),
        is_listing: this.searchForm.getFieldValue('is_listing'),
        is_zero: this.searchForm.getFieldValue('is_zero'),
        sku: this.searchForm.getFieldValue('sku'),
      }
      this.$refs.table.refresh()
    },

    // 调拨
    handleChange() {
      let routertwo = this.$router.resolve({ name: 'allocation', params: {} })
      window.open(routertwo.href, '_blank');
    },
    //导出
    handleExport() {
      const params = {
        name: this.searchForm.getFieldValue('name'),
        branch_id: this.searchForm.getFieldValue('branch_id'),
        is_listing: this.searchForm.getFieldValue('is_listing'),
        is_zero: this.searchForm.getFieldValue('is_zero'),
        sku: this.searchForm.getFieldValue('sku'),
        token: this.$ls.get(ACCESS_TOKEN)
      }
      window.open("/api/admin/stocks/excel" + encodeJsonToQuery(params))
    },
    // 查看
    handleView(row) {
      let routertwo = this.$router.resolve({ name: 'stockDetail', params: { id: row.id } })
      window.open(routertwo.href, '_blank');
    },
    handleDownload(img) {
      console.log(img)
    }
  },
}
</script>
<style scoped>
.pic {
  width: 50px;
  height: 50px;
  display: block;
}

.barcode {
  width: 150px;
  height: 50px;
}

.barcode>img {
  width: 150px;
  height: 50px;
  display: block;
}
</style>
